import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

import { PRIMENG_COLORS } from './model';

const LightModePalette = {
  surface: {
    0: '#ffffff',
    50: '{zinc.50}',
    100: '{zinc.100}',
    200: '{zinc.200}',
    300: '{zinc.300}',
    400: '{zinc.400}',
    500: '{zinc.500}',
    600: '{zinc.600}',
    700: '{zinc.700}',
    800: '{zinc.800}',
    900: '{zinc.900}',
    950: '{zinc.950}',
  },
};

const DarkModePalette = {
  surface: {
    0: '#ffffff',
    50: '{slate.50}',
    100: '{slate.100}',
    200: '{slate.200}',
    300: '{slate.300}',
    400: '{slate.400}',
    500: '{slate.500}',
    600: '{slate.600}',
    700: '{slate.700}',
    800: '{slate.800}',
    900: '{slate.900}',
    950: '{slate.950}',
  },
};

export const DefaultPreset = definePreset(Aura, {
  semantic: {
    primary: PRIMENG_COLORS['floodwaive'],
    colorScheme: {
      light: LightModePalette,
      dark: DarkModePalette,
    },
  },
});


